import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names with Tailwind-aware conflict resolution.
 *
 * Combines {@link clsx} (conditional class composition) with
 * {@link twMerge} (so later Tailwind utilities override earlier conflicting
 * ones). This is the standard shadcn/ui class helper used by every copied-in
 * component under `~components/ui`.
 *
 * @param inputs - Class values (strings, arrays, or conditional objects).
 * @returns A single, de-duplicated class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
